import styled from 'styled-components'

// PAX ALERT STYLES STARTS
export const PaxAlertWrapper = styled.div`
	width: 100%;
	height: 32px;
	background: #fdecef;
	display: flex;
	align-items: center;
	justify-content: space-around;
`

const AlertText = styled.span`
	font-weight: 600;
	font-size: 14px;
	line-height: 18px;
	letter-spacing: -0.3px;
	color: #d73c54;
`

const AlertLink = styled.span`
	font-weight: 600;
	font-size: 14px;
	line-height: 18px;
	letter-spacing: -0.3px;
	color: #1895b3;
	cursor: pointer;
`
// PAX ALERT STYLES ENDS

export const PaxAlertRenderer = ({
	alertContent = '',
	links = [
		{
			text: `+ Add room`,
			clickAction: () => {},
		},
	],
}) => {
	return (
		<PaxAlertWrapper>
			<AlertText>{alertContent}</AlertText>
			{links.map((link, linkIndex) => (
				<AlertLink key={linkIndex} onClick={link.clickAction}>
					{link.text}
				</AlertLink>
			))}
		</PaxAlertWrapper>
	)
}
